<template>
  <div class="tabbar_box">
    <div class="tab_box">
      <div class="logo_box">
        <img class="logo" src="@/assets/logo2.png" mode="widthFix" alt="" />
        <div class="title_box">
          <div class="logo_ch_title">保际非遗网</div>
          <div class="logo_en_title">BAOJI FEIYIWANG</div>
        </div>
      </div>
      <div class="nav_box">
        <el-tabs v-model="activeName" @tab-click="handleClick" ref="tabs">
          <el-tab-pane
            v-for="(item, index) in tabList"
            :label="item.title"
            :name="String(index)"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
        <i
          v-if="isShow"
          :style="{ left: trianglePosition + 'px' }"
          class="triangle el-icon-caret-top"
        ></i>
      </div>
      <div class="ava" @click="submitLogin">
        <el-avatar
          :size="40"
          :src="userInfo && userInfo.userHeadImg"
          icon="el-icon-user-solid"
        />
        <el-dropdown @command="command">
          <div class="ava-name">
            {{ (userInfo && userInfo.studentName) || '未登录' }}
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      :class="['second_tabs_box', { show: isShow }]"
      @mouseleave="handleMoseLeave"
    >
      <div
        class="second_tabs_list"
        v-for="(item, index) in tabList[activeName].children"
        :key="index"
        @click="submitSecondTabs(item, index)"
      >
        <span class="flag" v-if="(index + 1) % 2 === 0 && index !== 0"></span>
        <!-- 在双数项前加 | -->
        {{ item.title }}
        <span
          class="flag"
          v-if="
            (index + 1) % 2 === 0 &&
            index !== tabList[activeName].children.length - 1
          "
        ></span>
        <!-- 在双数项后加 | -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import store from '@/store'
export default {
  data() {
    return {
      trianglePosition: 0, // 三角形的位置
      activeName: '0',
      // tabList: [{
      //         title: '首页',
      //         src: '/'
      //     }, {
      //         title: '行业动态',
      //         src: '/article',
      //         // children: [{
      //         //     title: "非遗技艺"
      //         // }]
      //     }, {
      //         title: '风采展示',
      //         src: '/about',
      //     }, {
      //         title: '研修学院',
      //         src: '/college',
      //         children: [{
      //                 title: "研修课程",
      //                 src: '/college/course'
      //             }
      //             // , {
      //             //     title: "模拟练习",
      //             //     src: '/college/study'
      //             // }
      //         ]
      //     }, {
      //         title: '非遗简志',
      //         src: '/master',
      //     }, {
      //         title: '云端登记',
      //         src: '/training',
      //         children: [{
      //                 title: "培训课程",
      //                 src: '/training/trainingList'
      //             }
      //             // , {
      //             //     title: "往期资讯"
      //             // }
      //         ]
      //     },
      //     {
      //         title: '匠艺精神馆',
      //         src: "https://www.cfm119.com/digitalmuseum/index.html"
      //     }
      // ],
      tabList: [
        {
          title: '首页',
          src: '/',
        },
        {
          title: '非遗资讯',
          src: '/article',
          // children: [{
          //     title: "非遗技艺"
          // }]
        },
        {
          title: '非遗培训',
          src: '/training',
          children: [
            {
              title: '培训课程',
              src: '/training/trainingList',
            },
            // , {
            //     title: "往期资讯"
            // }
          ],
        },
        {
          title: '非遗学院',
          src: '/college',
          children: [
            {
              title: '非遗课程',
              src: '/college/course',
            },
            // , {
            //     title: "模拟练习",
            //     src: '/college/study'
            // }
          ],
        },
        {
          title: '非遗大师',
          src: '/master',
        },
        {
          title: '关于我们',
          src: '/about',
        },
        {
          title: '付费资讯',
          src: '/paidNews',
        },
        {
          title: '在线商城',
          src: '/shopping',
        },
      ],
      isShow: false,
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    $route(to) {
      const index = this.tabList.findIndex((item) => {
        if (item.src && item.src.includes(to.path)) {
          return true
        }
        if (item.children) {
          return item.children.some(
            (child) => child.src && child.src.includes(to.path)
          )
        }
        return false
      })

      if (index !== -1) {
        this.activeName = String(index) // 设置 activeName 为匹配项的下标
      }
    },
  },
  mounted() {
    this.setActiveTab()
    this.updateTrianglePosition()
  },
  methods: {
    command() {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('baojiToken')
      store.commit('user/SET_USER_INFO', null)
      Message({
        type: 'success',
        message: '已退出登录',
      })
      if (this.$router.currentRoute.path !== '/') {
        this.$router.replace('/')
      }
    },
    submitLogin() {
      const token = getToken()
      const userInfo = localStorage.getItem('userInfo')
      if (!token || !userInfo) {
        Message({
          type: 'error',
          message: '请先登录获取账户信息！',
        })
        if (this.$router.currentRoute.path !== '/') {
          this.$router.replace('/')
        }
        store.commit('user/SET_MODULE_FLAG', true)
        return
      }
    },
    submitSecondTabs(item, index) {
      if (this.$router.currentRoute.path !== item.src) {
        this.$router.push({
          path: item.src,
        })
      }

      console.log(item, 'item')
    },
    setActiveTab() {
      // 获取当前路径
      const currentPath = this.$route.path

      // 遍历 tabList 找到匹配的 tab
      let activeIndex = '0' // 默认首页
      this.tabList.forEach((tab, index) => {
        if (tab.children) {
          // 检查子菜单
          const childMatch = tab.children.find((child) =>
            currentPath.includes(child.src)
          )
          if (childMatch) {
            activeIndex = String(index)
          }
        } else if (tab.src && currentPath.startsWith(tab.src)) {
          // 检查一级菜单
          activeIndex = String(index)
        }
      })

      // 设置激活的 tab
      this.activeName = activeIndex

      // 控制二级菜单显示
      this.isShow = !!this.tabList[activeIndex].children
    },
    handleMoseLeave() {
      this.isShow = false
    },
    handleClick(tab, event) {
      console.log(this.activeName, 'this.activeNamethis.activeName')
      if (this.activeName == 6) {
        console.log(tab, 'tabbbbbb')
        window.open(this.tabList[this.activeName].src)
        return
      }
      if (
        this.tabList[this.activeName].children &&
        this.tabList[this.activeName].children.length > 0
      ) {
        this.isShow = true
      } else {
        this.isShow = false
      }
      this.$router
        .push({
          path: this.tabList[this.activeName].src,
        })
        .catch((err) => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
      console.log(this.isShow, 'isSHow')
      this.updateTrianglePosition()
    },
    updateTrianglePosition() {
      // 获取当前激活的标签页 DOM 元素
      this.$nextTick(() => {
        const tabs = this.$refs.tabs.$el.querySelectorAll('.el-tabs__item')
        const activeTab = tabs[this.activeName]
        if (activeTab) {
          // 计算三角形位置：标签页的中心位置
          const tabWidth = activeTab.offsetWidth
          const tabLeft = activeTab.offsetLeft
          this.trianglePosition = tabLeft + tabWidth / 2 - 8 // 8是三角形的宽度的一半
        }
      })
    },
  },
}
</script>
<style scoped>
::v-deep .el-tabs__nav-wrap::after {
  height: 0 !important;
}

::v-deep .el-tabs__active-bar {
  background-color: #c44004 !important;
}

::v-deep .el-tabs__item:hover {
  color: #000 !important;
}

::v-deep .el-tabs__item {
  padding: 0 30px !important;
  font-size: 16px !important;
}

::v-deep .el-tabs__item.is-active {
  color: #000;
  font-weight: 700;
}
</style>
<style lang="scss" scoped>
.tabbar_box {
  position: relative;
  background-color: #fff;

  .tab_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 50px;
    height: 100px;

    .logo_box {
      display: flex;
      align-items: center;

      .logo {
        width: 100px;
      }

      .title_box {
        padding-left: 10px;
        color: #000;
        .logo_ch_title {
          padding-bottom: 5px;
          font-weight: 700;
          font-size: 24px;
          letter-spacing: 6px;
        }

        .logo_en_title {
          font-size: 12px;
          letter-spacing: 3px;
          font-family: 'Times New Roman', Times, serif;
        }
      }
    }

    .nav_box {
      position: relative;

      .triangle {
        position: absolute;
        bottom: -4px;
        width: 0;
        height: 0;
        transition: left 0.3s ease;
        color: #c44004;
        /* 平滑过渡效果 */
      }
    }

    .ava {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
      text-align: center;
      cursor: pointer;

      .ava-name {
        word-wrap: normal;
        margin-top: 5px;
        width: 110px;
        overflow: hidden;
        -ms-text-overflow: ellipsis;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #7c7c7c;
        font-size: 14px;
      }
    }
  }

  .second_tabs_box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 999;
    color: #fff;
    background-color: #c44004;
    height: 0;
    /* 初始高度为 0 */
    opacity: 0;
    /* 初始透明度为 0 */
    transition: all 0.3s ease;
    /* 平滑过渡效果 */
    overflow: hidden;
    /* 隐藏超出部分 */
    font-size: 14px;

    .second_tabs_list {
      cursor: pointer;

      .flag {
        padding: 1px;
        background-color: rgba(255, 255, 255, 0.8);
        margin: 0 30px;
      }
    }
  }

  .second_tabs_box.show {
    height: 50px;
    /* 最终高度 */
    opacity: 1;
    /* 完全显示 */
  }
}
</style>
